<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="600px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip
        top
        color="black"
        :activator="$refs.btn"
        :value="tooltip"
      >
        <span>{{ $t('TaskList.TakeBackDoc') }}</span>
      </v-tooltip>
      <v-btn
        ref="btn"
        icon
        color="red"
        class="v-btn--outlined-bold"
        v-bind="attrs"
        v-on="on"
        @click="getReceiverDetailInfo"
        @mouseover="tooltip = true"
        @mouseleave="tooltip = false"
      >
        <v-icon>{{ mdiUndoVariant }}</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>{{ $t('eDocInternal.docDetail.receiver') }}</v-card-title>
      <v-divider />
      <v-skeleton-loader
        v-if="pageLoading"
        type="list-item-avatar-two-line, divider, list-item-avatar-two-line"
      />
      <div
        v-if="!pageLoading"
        class="pa-2"
      >
        <template v-if="!pageLoading && receiverList && receiverList.length === 0">
          <v-sheet>
            <div class="px-4 py-3">
              {{ $t('PublicServant.NoData') }}
            </div>
          </v-sheet>
        </template>
        <v-simple-table>
          <tbody>
            <tr
              v-for="(item, index) in receiverList"
              :key="item.id"
            >
              <td
                class="pr-0"
                style="min-width: 80px;"
              >
                {{ showReceiverOrGroupName(item) }}
              </td>
              <td class="pr-0">
                {{ momentWithHyphen(item.confirmReceivedTime).format('YYYY-MM-DD HH:mm') }}
              </td>
              <td class="pr-0">
                <v-btn
                  v-if="!item.confirmReceivedTime"
                  small
                  :loading="loading[index]"
                  @click="revokeProcess(item.id, index)"
                >
                  {{ $t('TaskList.TakeBackDoc') }}
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
      <v-card-actions>
        <v-btn
          color="primary"
          text
          @click="closeDialog"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { momentWithHyphen } from '@/utils/datetimeUtil'
import docFlowApi from '@/api/eDocInternal/docFlow'
import { mdiArrowLeft, mdiArrowDownBoldOutline, mdiUndoVariant } from '@mdi/js'
import { docFlowMethod } from '@/mixins/docFlowMethod'
// import { mapState } from 'vuex'
// import { docFlowModule } from '@/store/moduleName'

export default {
  mixins: [docFlowMethod],
  props: {
    processId: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      mdiArrowDownBoldOutline: mdiArrowDownBoldOutline,
      mdiArrowLeft: mdiArrowLeft,
      mdiUndoVariant: mdiUndoVariant,
      dialog: false,
      receiverList: [],
      loading: [],
      tooltip: false,
      pageLoading: false
    }
  },
  computed: {

  },
  created () {
    // this.getProcessLeaf(this.processId)
  },
  methods: {
    async getReceiverDetailInfo () {
      this.pageLoading = true
      await docFlowApi.getProcessReceiverDetailInfo(this.processId, resp => {
        this.receiverList = resp.data
      })
      this.pageLoading = false
    },

    revokeProcess (revokeProcessId, index) {
      this.$set(this.loading, [index], true)
      docFlowApi.revokeProcess(this.processId, revokeProcessId, resp => {
        if (resp.status === 201 || resp.status === 200) {
          this.getReceiverDetailInfo()
        }
        this.$set(this.loading, [index], false)
      })
    },

    closeDialog () {
      this.$emit('refreshReceiverInfo')
      this.dialog = false
    },

    momentWithHyphen
  }
}
</script>
